import EarlyBirdQualification from './EarlyBirdQualification';
import EarlyBirdEnrollment from './EarlyBirdEnrollment';

export default class ClientEarlyBirdDto {
  /**
   * @type {EarlyBirdQualification}
   */
  qualification;

  /**
   * @type {EarlyBirdEnrollment}
   */
  enrollment;

  /**
   * @type {boolean}
   */
  didOptOut = false;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.qualification != null) {
        this.qualification = new EarlyBirdQualification(opts.qualification);
      }
      if (opts.enrollment != null) {
        this.enrollment = new EarlyBirdEnrollment(opts.enrollment);
      }
      if (opts.didOptOut != null) {
        this.didOptOut = opts.didOptOut;
      }
    }
  }
}
